
import kirbyimage from '../kirbyimage.vue'
import Kirbylink from '../kirbylink.vue'
export default {
  components: { kirbyimage, Kirbylink },
    name: "LargeCTA",
    props: {
        content: Object
    },
    data: function () { 
        return {
            paintstroke: this.content.showpaintstroke === 'true' ? "paintstroke" : ""
        }
    }
}
